export default {"src":"/_next/static/media/client-askona-auth-background.60341266.svg","height":880,"width":1440};